import Navbar from "./Navbar.js";
import Word from "./Word.js";
import Footer from "./Footer.js";
import "./Home.css";
import {useEffect, useState} from "react";
import { Helmet } from "react-helmet-async";
import FirebaseService from "./services/FirebaseService.js";

let now = new Date();

let sec = now.getUTCSeconds();
let min = now.getUTCMinutes();
let hrs = now.getUTCHours();
let days = now.getUTCDay();

let displayedSec = 59 - sec;
(sec > 49) ? displayedSec = "0" + displayedSec : displayedSec += "";
let displayedMin = 59 - min;
(min > 49) ? displayedMin = "0" + displayedMin : displayedMin += "";
let displayedHrs = 23 - hrs;
(hrs > 13) ? displayedHrs = "0" + displayedHrs : displayedHrs += "";

export default function Home() {
    const [dailyTimer, setDailyTimer] = useState(`${displayedHrs}:${displayedMin}:${displayedSec}`);
    const [day, setDay] = useState(days);
    const [wordOfDay, setWordOfDay] = useState({
        "word": "Expand Your Vocabulary Daily",
        "defs": [{"partOfSpeech": "Noun", "definitions": ["def1", "def2", "def3"]}, {"partOfSpeech": "Verb", "definitions": ["def1", "def2", "def3"]}],
        "img": "./logo192.png",
    });

    useEffect(() => {
        const interval = setInterval(() => {
                
            now = new Date();

            sec = now.getUTCSeconds();
            min = now.getUTCMinutes();
            hrs = now.getUTCHours();
            days = now.getUTCDay();

            
            displayedSec = 59 - sec;
            (sec > 49) ? displayedSec = "0" + displayedSec : displayedSec += "";
            displayedMin = 59 - min;
            (min > 49) ? displayedMin = "0" + displayedMin : displayedMin += "";
            displayedHrs = 23 - hrs;
            (hrs > 13) ? displayedHrs = "0" + displayedHrs : displayedHrs += "";

            setDailyTimer(`${displayedHrs}:${displayedMin}:${displayedSec}`);
            setDay(days);
        }, 1000);
        return () => clearInterval(interval);
    }, []);
    
    useEffect(() => {

        
        (async () => {
            const yesterdayWord = wordOfDay.word;
            for (let i = 0; i < 50; i++) {
                // Gets Data for wordOfDay
                const wordOfDayData = await FirebaseService.getWordData();
                setWordOfDay(wordOfDayData);
                if (wordOfDayData.word !== yesterdayWord) {
                    break;
                } else if (i === 49) {
                    console.error("Error: Word of the day never changed in Firestore.");
                }
                await new Promise((resolve) => setTimeout(resolve, 2000));
            }
        })();

        
    }, [day, wordOfDay?.word]);

    return(
        <>
            <Helmet>
                <title>Diction Daily | {wordOfDay?.word || "Expand Your Vocabulary Daily"}</title>
                <meta name="keywords" content="Daily Word Learning, Expand Vocabulary, Word of the Day, Learn a New Word Daily, Improve English Vocabulary, Fun Words to Learn, Vocabulary Builder, English Learning for Beginners, Daily Language Tips" />
                <meta name="description" content={"Strengthen your vocabulary every day with Diction Daily!"} />
                <meta property="og:image" content={wordOfDay.img} />
                <meta property="og:url" content="https://dictiondaily.com" />
                <link rel="canonical" href="https://dictiondaily.com" />
                <meta property="og:type" content="website" />
            </Helmet>
            <Navbar />

            <div className="word-of-day-content-container">
                <>{(wordOfDay.word !== "Expand Your Vocabulary Daily") ? (<Word word={wordOfDay.word} definitions={wordOfDay.defs} image={wordOfDay.img} object_name={"wordOfDay"} daily_timer={dailyTimer}/>) : (<div className="loading-wheel"></div>)}</>
            </div>

            <Footer />
        </>
    );
}

